import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton } from "@/components/AuthShell";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/my-rituals", { replace: true });
  }, [user, loading, navigate]);

  return (
    <AuthShell>
      <div className="w-full max-w-md text-center">
        <p className="eyebrow">A community by ELA Rituals</p>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-forest">Welcome back</h1>
        <p className="mt-4 text-charcoal/70">Sign in to your Rituals With You account.</p>
        <div className="mt-8">
          <GoogleButton next="/my-rituals" label="Sign in with Google" />
        </div>
        <p className="mt-6 text-sm text-charcoal/60">
          New here?{" "}
          <a href="/join" className="text-forest underline underline-offset-4">Join the Community</a>
        </p>
      </div>
    </AuthShell>
  );
}
